//BRC-855 added :not(.remove-toggle-fix) to the end of the query selector so that we can pass the class to the card details toggle
// without it, it would remove the arrow svg on button click
let triggers = document.body.querySelectorAll(
  '[data-toggle="trigger"]:not(.accordion__title-container):not(.remove-toggle-fix)'
)

triggers.forEach(function(el) {
  el.addEventListener('click', function(e) {
    if (e.target.innerText.indexOf('+') !== -1) {
      e.target.innerText = e.target.innerText
        .replace('+', '-')
        .replace('More', 'Less')
    } else {
      e.target.innerText = e.target.innerText
        .replace('-', '+')
        .replace('Less', 'More')
    }
  })
})
